import type { Box, Layout } from '$lib/types/Components/SharedTypes';

export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 992;

export const DEFAULT_LAYOUT: Layout = {
    isInList: false,
    isInSingleColumn: false,
    isInColumn: false,
    isInFramedColumn: false,
    isInMultiColumn: false,
    columnCount: 0,
};

export const DEFAULT_BOX: Box = {
    top: 'none',
    right: 'none',
    bottom: 'none',
    left: 'none',
    backgroundColor: 'transparent',
};

// Logos block
export const LOGO_WIDTH_M = 160;
export const LOGO_WIDTH_L = 240;
export const ANIMATION_SPEED = 0.3; // logos/s

export const TW_BLUE_600 = '#2563eb';

// CAP-4418: How long a page holds back the blocks below a sandboxed AI embed
// that has not reported its height yet (see `$lib/Stores/blockReveal`). On the
// reporting funnel every embed has settled by ~1.2s, so this covers the normal
// case with room to spare while keeping the worst case — a sandbox that never
// answers — short enough that the page is never left half-invisible.
export const PAGE_REVEAL_TIMEOUT_MS = 2000;
